import { render } from "./Project.vue?vue&type=template&id=b5756eb2"
import script from "./Project.vue?vue&type=script&lang=ts"
export * from "./Project.vue?vue&type=script&lang=ts"
script.render = render

export default script